import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            return 'dato';
        case 'dato':
            nextPage = 'tidspunkt';
            break;
        case 'tidspunkt':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'vaelg-koeretoej';
            break;

        case 'vaelg-koeretoej':
            const registratioNumberField = getValueOrDefault(formConfig, formValues, 'registrationNumber');
            const { registrationNumber } = registratioNumberField;

            // If no registationNumber.registrationNumber alway to andet-koeretoej-nummerplade
            if (registrationNumber === '') {
                nextPage = 'andet-koeretoej-nummerplade';
            } else {
                nextPage = 'var-koeretoejet-laast';
            }
            break;

        case 'andet-koeretoej-nummerplade':
            nextPage = 'om-andet-koeretoej';
            break;

        case 'om-andet-koeretoej':
            nextPage = 'var-koeretoejet-laast';
            break;

        case 'var-koeretoejet-laast':
            nextPage = 'noegler';
            break;

        case 'noegler':
            nextPage = 'mistet-noegler';
            break;

        case 'mistet-noegler':
            nextPage = 'antal-noegler';
            break;

        case 'antal-noegler':
            nextPage = 'er-koerertoejet-fundet';
            break;
        // 10
        case 'er-koerertoejet-fundet':
            if (getValueOrDefault(formConfig, formValues, 'isVehicleFound').value === 'yes') {
                nextPage = 'skader';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        // 10a
        case 'skader':
            const isCustomerWithExistingVehiclePolicy =
                getValueOrDefault(formConfig, formValues, 'registrationNumber').hasVehiclesInSystem === 'yes';

            const isVehicleTypeOtherSelected = isCustomerWithExistingVehiclePolicy
                ? getValueOrDefault(formConfig, formValues, 'registrationNumber').registrationNumber === '' &&
                  getValueOrDefault(formConfig, formValues, 'vehicleTypeOther').value === 'other'
                : getValueOrDefault(formConfig, formValues, 'registrationNumber').entityType === 'others';

            if (
                getValueOrDefault(formConfig, formValues, 'isVehicleDamaged').value === 'yes' &&
                !isVehicleTypeOtherSelected
            ) {
                nextPage = 'skadezoner';
            } else if (
                getValueOrDefault(formConfig, formValues, 'isVehicleDamaged').value === 'yes' &&
                isVehicleTypeOtherSelected
            ) {
                nextPage = 'hvilke-skader';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        //page 10b - skadezoner
        case 'skadezoner':
            nextPage = 'dokumentation';
            break;

        //page 10c - hvilke-skader
        case 'hvilke-skader':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'politi-og-samtykke';
            break;

        case 'politi-og-samtykke':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Y') {
                nextPage = 'samtykke';
            } else {
                nextPage = 'om-dig';
            }
            break;

        case 'samtykke':
            nextPage = 'om-dig';
            break;

        case 'om-dig':
            nextPage = 'resume';
            break;

        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
